import styled, { css } from "styled-components";
import { Atom } from 'AppReact';

const template = styled.div`
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-decoration-line: underline;
`;

export default Atom({ type: 'label', dataType: 'string', template })